import { AuthUser } from 'components/Session/withAuthentication'
import { action } from '../dispatchAction'
import { AUTH_USER_ACTION_TYPES } from './types'

export const setAuthUser = (authUser: AuthUser) => async dispatch => {
  dispatch(action(AUTH_USER_ACTION_TYPES.set_auth_user, { authUser }))
}



// WEBPACK FOOTER //
// ./src/store/authUser/actions.ts